(function () {
  "use strict";

  // Check if the custom element is already registered to avoid re-defining it
  if (!customElements.get("quantity-counter")) {
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.input = this.querySelector("input");
          this.changeEvent = new Event("change", { bubbles: true });

          const cartItem = this.closest(".cart__item");

          // Bind event listeners to maintain 'this' context
          this.buttonClickEvent = this.onButtonClick.bind(this);
          this.onQuantityChangeEvent = this.onQuantityChange.bind(this);

          // Add event listeners
          this.input.addEventListener("change", this.onQuantityChangeEvent);
          this.querySelectorAll("button").forEach((button) => {
            button.addEventListener("click", this.buttonClickEvent);
          });

          this.addons = cartItem ? this.closest(".cart__item").querySelectorAll("cart-addon-item") : [];
        }

        onButtonClick(event) {
          event.preventDefault();
          
          const previousValue = this.input.value;
          const button = event.target.nodeName === "BUTTON" 
            ? event.target 
            : event.target.closest("button");

          if (button.name === "increase") {
            this.input.stepUp();
          }

          if (button.name === "decrease") {
            this.input.stepDown();
          }

          // Trigger change event if value actually changed
          if (previousValue !== this.input.value) {
            this.input.dispatchEvent(this.changeEvent);
          }
        }

        onQuantityChange() {
          if (this.input.name === "updates[]") {
            this.updateCart();
          }
        }

        updateCart() {
          if (this.input.value !== "") {
            const cartItem = this.closest(".cart__item");
            const addon = Array.from(this.addons).find(
              (item) => item.dataset.addonToken === cartItem.dataset.addonToken
            );

            this.dispatchEvent(
              new CustomEvent("theme:cart:update", {
                bubbles: true,
                detail: {
                  id: this.input.dataset.id,
                  quantity: this.input.value,
                  addon: addon ? { id: addon.dataset.addonKey } : null,
                },
              })
            );
          }
        }
      }
    );
  }
})();